import HomeView from './views/HomeView.vue';
import { createPage } from './pages/createPage';

// Точка входа главной страницы — index.html
createPage(HomeView, 'home');

